(() => {
    function initCollectionsSwiper(wrapId) {
        const wrap = document.getElementById(wrapId);
        if (!wrap) return;
        const container = wrap.querySelector("swiper-container");
        if (!container) return;

        // Slides count
        const slidesCount = wrap.querySelectorAll("swiper-slide").length;

        // Ensure Swiper Element polyfills are present (Swiper >= 9 provides custom elements build)
        const ensureSwiperElement = async () => {
            if (customElements.get("swiper-container")) return true;
            // Load from CDN if not present
            const loadScript = (src) =>
                new Promise((res, rej) => {
                    if (document.querySelector(`script[src="${src}"]`))
                        return res();
                    const s = document.createElement("script");
                    s.src = src;
                    s.async = true;
                    s.onload = res;
                    s.onerror = rej;
                    document.head.appendChild(s);
                });
            try {
                await loadScript(
                    "https://unpkg.com/swiper@9/element/bundle.min.js"
                );
                return true;
            } catch (e) {
                console.warn("Failed to load Swiper Element", e);
                return false;
            }
        };

        const init = () => {
            // Read options from data-attribute JSON
            let opts = {};
            try {
                opts = JSON.parse(
                    container.getAttribute("data-options") || "{}"
                );
            } catch (e) {
                opts = {};
            }

            // Helper: resolve slidesPerView for current viewport (from data-options breakpoints)
            const getPerView = () => {
                let per = Number(opts.slidesPerView || 1);
                if (opts.breakpoints && typeof window !== "undefined") {
                    const w = window.innerWidth;
                    let matched = per;
                    Object.keys(opts.breakpoints).forEach((bp) => {
                        const bpNum = parseInt(bp, 10);
                        if (!Number.isNaN(bpNum) && w >= bpNum) {
                            const cand =
                                opts.breakpoints[bp] &&
                                opts.breakpoints[bp].slidesPerView;
                            if (cand != null) matched = Number(cand);
                        }
                    });
                    per = matched;
                }
                return Math.max(1, per || 1);
            };

            // Disable interactions when slides are not enough for current viewport
            const perView = getPerView();
            const insufficient = slidesCount <= Math.floor(perView);
            opts.watchOverflow = false; // we control UI/interaction ourselves
            if (insufficient) {
                // Static mode: keep visual layout but no swipe/loop
                opts.allowTouchMove = false;
                opts.loop = false;
            } else {
                opts.allowTouchMove = true;
            }

            // Wire external controls
            opts.navigation = {
                nextEl: wrap.querySelector(".custom-next-button"),
                prevEl: wrap.querySelector(".custom-prev-button")
            };
            opts.scrollbar = {
                el: wrap.querySelector(".custom-scrollbar"),
                draggable: true,
                hide: false
            };

            // Assign options as props to the element and init
            Object.assign(container, opts);
            if (typeof container.initialize === "function")
                container.initialize();

            // UI toggle and resize handler
            const inst = container.swiper; // available after initialize()
            // Ensure Swiper won't auto-lock due to overflow heuristics
            if (inst && inst.params) inst.params.watchOverflow = false;

            const setStaticUi = (isStatic) => {
                const prev = wrap.querySelector(".custom-prev-button");
                const next = wrap.querySelector(".custom-next-button");
                const bar = wrap.querySelector(".custom-scrollbar");
                if (isStatic) {
                    prev && prev.setAttribute("hidden", "");
                    next && next.setAttribute("hidden", "");
                    bar && bar.setAttribute("hidden", "");
                } else {
                    prev && prev.removeAttribute("hidden");
                    next && next.removeAttribute("hidden");
                    bar && bar.removeAttribute("hidden");
                }
            };

            setStaticUi(insufficient);

            // Re-evaluate on resize
            const debounce = (fn, t = 150) => {
                let id;
                return (...a) => {
                    clearTimeout(id);
                    id = setTimeout(() => fn(...a), t);
                };
            };
            const onResize = debounce(() => {
                if (!container || !container.swiper) return;
                const pv = getPerView();
                const isStatic = slidesCount <= Math.floor(pv);
                const p = container.swiper.params;
                p.watchOverflow = false; // never auto-lock
                p.allowTouchMove = !isStatic;
                p.loop = !isStatic && Boolean(opts.loop);
                container.swiper.update && container.swiper.update();
                setStaticUi(isStatic);
            }, 150);
            window.addEventListener("resize", onResize);

            // Micro-interactions
            if (matchMedia("(hover: hover)").matches) {
                const maxTilt = 2; // degrees
                wrap.querySelectorAll(".js-tilt-target").forEach((card) => {
                    card.addEventListener("mousemove", (e) => {
                        const r = card.getBoundingClientRect();
                        const x = (e.clientX - r.left) / r.width - 0.5;
                        const y = (e.clientY - r.top) / r.height - 0.5;
                    });
                    card.addEventListener("mouseleave", () => {
                        card.style.transform = "";
                    });
                });
            }

            // Center emphasis effect
            if (inst) {
                inst.on("progress", () => {
                    inst.slides.forEach((slide) => {
                        const p = slide.progress;
                        const s = 1 - Math.min(Math.abs(p) * 0.06, 0.06);
                        slide.style.transform = `scale(${s})`;
                        slide.style.opacity = String(
                            1 - Math.min(Math.abs(p) * 0.2, 0.2)
                        );
                    });
                });
            }
        };

        (async () => {
            if (await ensureSwiperElement()) init();
        })();
    }

    // Process any queued section IDs (pushed before this script ran)
    const queue = Array.isArray(window.__atlasCollectionSwiperQueue)
        ? window.__atlasCollectionSwiperQueue
        : [];
    queue.forEach((id) => initCollectionsSwiper(id));

    // Expose for any IDs pushed after this script ran (shouldn't happen with defer, but just in case)
    window.__atlasCollectionSwiperQueue = {
        push: (id) => initCollectionsSwiper(id)
    };
})();
